import { useCallback } from 'react';
import { pick } from 'ramda';

import { useDeviceSelector } from 'js/store/hooks';

export const useIsSupportedBrowser = () => {
    const { browserName, browserVersion, ua } = useDeviceSelector(pick(['browserName', 'browserVersion', 'ua']));

    return useCallback((supportedBrowsersVersions) => {
        const version = parseInt(browserVersion);
        let isSupported = false;

        if (!Object.keys(supportedBrowsersVersions).length) {
            return true;
        }

        switch (browserName) {
            case 'ie':
                isSupported = version >= supportedBrowsersVersions.ie;
                break;
            case 'uc':
                isSupported = true;
                break;
            case 'edge':
                isSupported = version >= supportedBrowsersVersions.edge;
                break;
            case 'chrome':
                isSupported = !ua.includes('yabrowser') && version >= supportedBrowsersVersions.chrome;
                break;
            case 'safari':
                isSupported = version >= supportedBrowsersVersions.safari;
                break;
            case 'firefox':
                isSupported = version >= supportedBrowsersVersions.firefox;
                break;
            case 'opera':
                isSupported = false;
                break;
            case 'androidNative':
                // Only an old Samsung Internet version should be considered as native
                isSupported = !(supportedBrowsersVersions.androidNative && /SamsungBrowser\/([\d.]+)/i.exec(ua) && version < 44);
                break;

            default:
                break;
        }

        return isSupported;
    }, [browserName, browserVersion, ua]);
};
